import { backendBaseUrl } from '../services/api';

export function Login() {
  const href = `${backendBaseUrl}/auth/google`;

  return (
    <div className="page page-center">
      <div className="container container-tight py-4">
        <div className="text-center mb-4">
          <h1 className="h2">NA Florida — Workgroup Management</h1>
        </div>
        <div className="card card-md">
          <div className="card-body">
            <h2 className="h3 text-center mb-4">Sign in</h2>
            <p className="text-secondary text-center mb-4">
              Use your <strong>@naflorida.org</strong> Google account.
            </p>
            <div className="text-center">
              <a href={href} className="btn btn-primary w-100">
                Sign in with Google
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
